import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2023-08-03T11:00",
		title: `
<h4>第5回日本在宅医療連合学会大会オンデマンド配信のご案内</h4>
<p class="paragraph-indent">
●2023年6月24・25日、新潟市朱鷺メッセにて日本在宅医療連合学会大会が開催されました。<br>
新潟県医師会在宅医療推進センターは新潟県プログラム委員会として大会に参画いたしました。<br>
8月31日まで、参加登録によりオンデマンド配信の視聴が可能です。<br>
ぜひご視聴ください。<br>
・<a href="${topicsDir}/2023/08-5thtaikai_on-demand.pdf">オンデマンド配信更新のお知らせ</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	},
	{
		date: "2023-08-21T11:00",
		title: `
<h4>新潟県医師会在宅医療推進センターより</h4>
<p class="paragraph-indent">
●第15回在宅ケアを考える集いin越後2023を開催します。<br>
<em>テーマ：</em>医療資源が少ない新潟県の未来に向けて<br>　　　　～在宅ケアにおいて何を行うべきか～<br>
<em>日時：</em>令和5年9月23日（土・祝）13:00～17:00<br>
<em>参加定員：</em>200名　※事前申込みが必要です<br>
・<a href="${topicsDir}/2023/08-15thzaitaku-care.pdf">詳しくは案内チラシをご覧ください。</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
